var messages = {
  'zh-CN': {
    message: {
      '0': '请求成功',
      '-1': '请求失败',
      '10160000': '系统繁忙，请稍后再试！',
      '10163001': '缺少老师信息',
      '10163002': '未知课程类型',
      '10163003': '找不到考季',
      '10163004': '课程未设置考季',
      '10163005': '人满了',
      '10163006': '占位失败，换个试试',
      '10163007': '没有找到自习室',
      '10163008': '座位有人了',
      '10163009': '体验用户不能进入正式的班级',
      '10163010': '无自习室信息~',
      '10163011': '用户还没有当前的课程',
      '10163020': '课程下无班级！',
      '10163021': '学生还未入班！',
      '10163022': '学管信息获取失败',
      '10163023': '无学管信息',
      '10163024': '未知资源类型',
      '10163025': '查询异常，查询结果不唯一！',
      '10163026': '学员入学未满一个星期，将在下周一生成一周学习报告。',
      '10163027': '当前考季已经选择过带学直播期次',
      '10163028': '未找到带学直播',
      '10163029': '未找到指定课程',
      '10163030': '您的网络可能有问题，请稍后重试!',
      '10163040': '学生未设置考季',
      '10163041': '不支持该资源类型',
      '10433001': '参数错误',
      '10433010': '找不到课程',
      '10433002': '学生ID不能为空',
      '10433003': 'ID不能为空',
      '10433011': '课程讲义分类最多只能添加5个哦',
      '10433012': '课程讲义分类ID不能为空',
      '10433013': '该课程讲义分类已存在',
      '10433014': '该讲义分类已被使用，不能删除',
      '10433015': '课程讲义分类名称不能为空',
      '10433016': '讲义大小不能为空',
      '10433017': '未找到对应讲义或讲义已删除',
      '10433020': '二次开启时间不可早于首次开启时间！',
      '10433021': '结束时间不可早于首次/二次开启时间！',
      '10434000': '暂无内容',
      '10435000': '添加资源失败',
      '10436000': '清缓存失败',
      '10435001': '课程大纲为空',
      '10435002': '课程大纲条目不存在',
      '10434001': '没有权限',
      '10153001': '参数错误',
      '10153002': '无数据',
      '10153003': 'token解析失败！',
      '10153004': '无效token!',
      '10153005': '缺少学生ID',
      '10153006': '接口无响应',
      '10153007': '没有权限',
      '10153008': '操作失败，建议重试',
      '10153009': '字数超出限制.',
      '10153010': 'ID为必须.',
      '10153011': '操作非法.',
      '10153012': '操作有点儿频繁，请稍后再试.',
      '10153013': '资源下面无笔记',
      '10153051': '资源类型有误.',
      '10153052': '试卷类型需要传入题目ID.',
      '10153053': '别急，测试时间未到.',
      '10153054': '资源未找到.',
      '10153055': '该资源不是试卷类型.',
      '10153056': '资源ID为必须.',
      '10153057': '日程下无资源',
      '10153071': '试卷创建失败.',
      '10153074': '交卷失败，建议重试.',
      '10153075': '未获取到报告信息，建议重试.',
      '10153076': '试卷已经提交，请勿重复提交.',
      '10153077': '当前试卷尚未提交.',
      '10153078': '重新生成试卷失败，建议重试.',
      '10153079': '不存在可批改记录.',
      '10153081': '试卷未绑定知识点，请联系管理员.',
      '10153082': '超过试卷最大重做限制次数.',
      '10153083': '未获取到试卷信息，请联系管理员.',
      '10153084': '试卷已被禁用.',
      '10153085': '暂无权限，请购买指定课程.',
      '10153086': '交卷失败,未找到答题信息，建议答题后重试.',
      '10153101': '题目来源非法.',
      '10153102': '暂无该考点的相关题目.',
      '10153121': '未找到该课程设置信息.',
      '10153122': '该课程没有考纲.',
      '10153151': '知识点ID为必须.',
      '10153201': '获取大纲条目信息失败，建议重试.',
      '10153202': '未获取获取大纲条目信息，建议重试.',
      '10153203': '本节未设置章节测试，请联系管理员.',
      '10153204': '章节测试未绑定试卷资源，请联系管理员.',
      '10153205': '本条目未开启跳级测试，请联系管理员.',
      '10153206': '本条目未开启提分盒子，请联系管理员.',
      '10153301': '本条目跳级测试未开启.',
      '10153321': '提分盒子已经提交，不可重复做.',
      '10153322': '暂时没有权限开启提分盒子.',
      '10153323': '没有找到题目，请联系管理员.',
      '10153341': '考试配置错误，请联系管理员.',
      '10153342': '未找到考试记录.',
      '10153343': '模拟机考试卷请前往电脑端练习.',
      '10153344': '考试参数不匹配.',
      '11061001': '请求错误',
      '11063001': '参数错误',
      '11063004': '未获取到大纲数据',
      '11063005': '学员当前尚未产生学习数据，您可以做好督学工作哦~',
      '11063006': '课程异常',
      '11063007': '课程起始信息未找到',
      '11063008': '课程还未开始学习',
      '11063013': '考季信息不存在',
      '11063017': '课程信息不存在',
      '11063018': '学生引导信息不存在',
      '11063019': '学生未走完引导',
      '11063021': '字典数据查询失败！项目id 转换失败！',
      '10013014': '未找到考季确认记录',
      '10013015': '欢迎新同学，这是您入学的第一周。我们将在每周一为您带来周学习报告哦~',
      '10013016': '您已超过考试时间，请重新选择考季哦~',
      '11063023': '班级信息不存在',
      '10083003': '收藏的问题不存在，请检查后重试',
      '10083005': '问题扩展保存失败',
      '10083004': '发生参数错误，请重试',
      '10083006': '问题不存在',
      '10083007': '问题被删除',
      '12101002': '找不到数据',
      '12101004': '重复操作',
      '12101005': '参数错误',
      '12101006': 'json转换失败',
      '12102001': '缺少必要参数',
      '12103001': '没有找到考纲数据',
      '12103101': '未找到条目信息',
      '12103201': '大纲不存在',
      '12103202': '仅支持直播/面授大纲',
      '10203001': '参数错误',
      '10010001': '无数据',
      '10010002': 'token解析失败！',
      '10010003': '无效token!',
      '10010004': '缺少学生ID',
      '10010005': '接口无响应',
      '10010006': '没有权限',
      '10010007': '未定义的场景,请联系学管',
      '10010008': '缺少用户ID',
      '10010009': '用户限制,没有项目权限',
      '10010015': '您的网络可能有问题，请稍后重试!',
      '55364943': '登录超时,请重新登录',
      '55364941': '无法效验token,请重新登录',
      '60010001': '暂无权限，请稍后再试哦~',
      '60010002': '直播地址错误，请稍后再试~',
      '10423002': '资源类型没有发现',
      '10423003': '资源类型discriminator不能为空',
      '10423007': '资源tag不存在',
      '10423009': '解析时间格式失败',
      '10423011': '资源不存在',
      '10423012': '资源ID不能为空',
      '10423013': '资源不能为空',
      '10423014': 'hermes直播资源不能为空',
      '10423018': '查询资源为空',
      '10423019': '视频资源不能为空，请检查参数是否正确',
      '10423025': '资源包不存在，请检查后重试'
    }
  },
  'zh-TW': {
    message: {
      '0': '請求成功',
      '-1': '請求失敗',
      '10160000': '系統繁忙，請稍後再試！',
      '10163001': '缺少老師信息',
      '10163002': '未知課程類型',
      '10163003': '找不到考季',
      '10163004': '課程未設置考季',
      '10163005': '人满了',
      '10163006': '佔位失敗，換個試試',
      '10163007': '沒有找到自習室',
      '10163008': '座位有人了',
      '10163009': '體驗用戶不能進入正式的班級',
      '10163010': '無自習室信息~',
      '10163011': '用戶還沒有當前的課程',
      '10163020': '課程下無班級！',
      '10163021': '學生還未入班！',
      '10163022': '學管信息獲取失敗',
      '10163023': '無學管信息',
      '10163024': '未知資源類型',
      '10163025': '查詢異常，查詢結果不唯一！',
      '10163026': '學員入學未滿一個星期，將在下週一生成一周學習報告。',
      '10163027': '當前考季已經選擇過帶學直播期次',
      '10163028': '未找到帶學直播',
      '10163029': '未找到指定課程',
      '10163030': '您的網絡可能有問題，請稍後重試!',
      '10163040': '學生未設置考季',
      '10163041': '不支持該資源類型',
      '10433001': '參數錯誤',
      '10433010': '找不到課程',
      '10433002': '學生ID不能為空',
      '10433003': 'ID不能為空',
      '10433011': '課程講義分類最多只能添加5個哦',
      '10433012': '課程講義分類ID不能為空',
      '10433013': '該課程講義分類已存在',
      '10433014': '該講義分類已被使用，不能刪除',
      '10433015': '課程講義分類名稱不能為空',
      '10433016': '講義大小不能為空',
      '10433017': '未找到對應講義或講義已刪除',
      '10433020': '二次開啟時間不可早於首次開啟時間！',
      '10433021': '結束時間不可早於首次/二次開啟時間！',
      '10434000': '暫無內容',
      '10435000': '添加資源失敗',
      '10436000': '清緩存失敗',
      '10435001': '課程大綱為空',
      '10435002': '課程大綱條目不存在',
      '10434001': '沒有權限',
      '10153001': '參數錯誤',
      '10153002': '無數據',
      '10153003': 'token解析失敗！',
      '10153004': '無效token!',
      '10153005': '缺少學生ID',
      '10153006': '接口無響應',
      '10153007': '沒有權限',
      '10153008': '操作失敗，建議重試',
      '10153009': '字數超出限制.',
      '10153010': 'ID為必須.',
      '10153011': '操作非法.',
      '10153012': '操作有點兒頻繁，請稍後再試.',
      '10153013': '資源下面無筆記',
      '10153051': '資源類型有誤.',
      '10153052': '試卷類型需要傳入題目ID.',
      '10153053': '別急，測試時間未到.',
      '10153054': '資源未找到.',
      '10153055': '該資源不是試卷類型.',
      '10153056': '資源ID為必須.',
      '10153057': '日程下無資源',
      '10153071': '試卷創建失敗.',
      '10153074': '交卷失敗，建議重試.',
      '10153075': '未获取到报告信息，建议重试.',
      '10153076': '未獲取到報告信息，建議重試.',
      '10153077': '當前試卷尚未提交.',
      '10153078': '重新生成試卷失敗，建議重試.',
      '10153079': '不存在可批改記錄.',
      '10153081': '試卷未綁定知識點，請聯繫管理員.',
      '10153082': '超過試卷最大重做限制次數.',
      '10153083': '未獲取到試卷信息，請聯繫管理員.',
      '10153084': '試卷已被禁用.',
      '10153085': '暫無權限，請購買指定課程.',
      '10153086': '交卷失敗,未找到答題信息，建議答題後重試.',
      '10153101': '題目來源非法.',
      '10153102': '暫無該考點的相關題目.',
      '10153121': '未找到該課程設置信息.',
      '10153122': '該課程沒有考綱.',
      '10153151': '知識點ID為必須.',
      '10153201': '獲取大綱條目信息失敗，建議重試.',
      '10153202': '未獲取獲取大綱條目信息，建議重試.',
      '10153203': '本節未設置章節測試，請聯繫管理員.',
      '10153204': '章節測試未綁定試卷資源，請聯繫管理員.',
      '10153205': '本條目未開啟跳級測試，請聯繫管理員.',
      '10153206': '本條目未開啟提分盒子，請聯繫管理員.',
      '10153301': '本條目跳級測試未開啟.',
      '10153321': '提分盒子已經提交，不可重複做.',
      '10153322': '暫時沒有權限開啟提分盒子.',
      '10153323': '沒有找到題目，請聯繫管理員.',
      '10153341': '考試配置錯誤，請聯繫管理員.',
      '10153342': '未找到考試記錄.',
      '10153343': '模擬機考試卷請前往電腦端練習.',
      '10153344': '考試參數不匹配.',
      '11061001': '請求錯誤',
      '11063001': '參數錯誤',
      '11063004': '未獲取到大綱數據',
      '11063005': '學員當前尚未產生學習數據，您可以做好督學工作哦~',
      '11063006': '課程異常',
      '11063007': '課程起始信息未找到',
      '11063008': '課程還未開始學習',
      '11063013': '考季信息不存在',
      '11063017': '課程信息不存在',
      '11063018': '學生引導信息不存在',
      '11063019': '學生未走完引導',
      '11063021': '字典數據查詢失敗！項目id 轉換失敗！',
      '10013014': '未找到考季確認記錄',
      '10013015': '歡迎新同學，這是您入學的第一周。我們將在每週一為您帶來週學習報告哦~',
      '10013016': '您已超過考試時間，請重新選擇考季哦~',
      '11063023': '班級信息不存在',
      '10083003': '收藏的問題不存在，請檢查後重試',
      '10083005': '問題擴展保存失敗',
      '10083004': '發生參數錯誤，請重試',
      '10083006': '問題不存在',
      '10083007': '問題被刪除',
      '12101002': '找不到數據',
      '12101004': '重複操作',
      '12101005': '參數錯誤',
      '12101006': 'json轉換失敗',
      '12102001': '缺少必要參數',
      '12103001': '沒有找到考綱數據',
      '12103101': '未找到條目信息',
      '12103201': '大綱不存在',
      '12103202': '僅支持直播/面授大綱',
      '10203001': '参数错误',
      '10010001': '無數據',
      '10010002': 'token解析失敗！',
      '10010003': '無效token!',
      '10010004': '缺少學生ID',
      '10010005': '接口無響應',
      '10010006': '沒有權限',
      '10010007': '未定義的場景,請聯繫學管',
      '10010008': '缺少用戶ID',
      '10010009': '用戶限制,沒有項目權限',
      '10010015': '您的網絡可能有問題，請稍後重試!',
      '55364943': '登錄超時,請重新登錄',
      '55364941': '無法效驗token,請重新登錄',
      '60010001': '暫無權限，請稍後再試哦~',
      '60010002': '直播地址錯誤，請稍後再試~',
      '10423002': '資源類型沒有發現',
      '10423003': '資源類型discriminator不能為空',
      '10423007': '資源tag不存在',
      '10423009': '解析時間格式失敗',
      '10423011': '資源不存在',
      '10423012': '資源ID不能為空',
      '10423013': '資源不能為空',
      '10423014': 'hermes直播資源不能為空',
      '10423018': '查詢資源為空',
      '10423019': '視頻資源不能為空，請檢查參數是否正確',
      '10423025': '資源包不存在，請檢查後重試'
    }
  },
  'en-US': {
    message: {}
  }
};
var translateLanguage = function (type, key) {
  //@ts-ignore
  if (!messages[type] || !messages[type].message || !messages[type].message[key]) {
    return '';
  }
  //@ts-ignore
  return messages[type].message[key];
};
export default translateLanguage;